import * as React from 'react';
import { RoundDeleteBtn } from '../input/Buttons';
import { Section } from './Section';

export interface SectionDynamicProps {
    children?: any;
    deleteOnClick: (index: number) => void;
    index: number;
}

export function SectionDynamic(props: SectionDynamicProps) {

    return (
        <Section>
            <RoundDeleteBtn buttonOnClick={() => props.deleteOnClick(props.index)} />
            {props.children}
        </Section>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/SectionDynamic.tsx